module.exports = __webpack_public_path__ + "static/featuredBlockLayout3Back-fbc69e53fe151b7773966d6f08dd9d41.png";